import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import CreateUpdatePlanBTFormPresenter from "../../../features/planBT/components/PlanBT/CreateUpdatePlanBTForm/CreateUpdatePlanBTFormPresenter";


export default function CreatePlanBTPage() {
  return (
    <>
    <HeaderTitleContent withGoBackBtn> Nouveau Plan BT </HeaderTitleContent>
    <CreateUpdatePlanBTFormPresenter />
    </>
  )
}
